export const formatViews = (
    views: number,
    labelText: {
        thousand: string;
        millions: string;
    },
): string => {
    if (views < 1000) {
        return views.toString();
    }

    if (views < 1000000) {
        const thousands = views / 1000;
        const formatted = thousands.toFixed(1).replace('.', ',');

        return `${formatted} ${labelText.thousand}`;
    }

    const millions = views / 1000000;
    const formatted = millions.toFixed(1).replace('.', ',');

    return `${formatted} ${labelText.millions}`;
};
